import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Garcom from './Garcom';
import {
  clearWaiterDeviceSession,
  fetchWaiterDeviceSession,
  getWaiterDeviceSession,
} from '../utils/waiterDeviceApi';

const WaiterOperation = () => {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let active = true;

    const validateSession = async () => {
      if (!getWaiterDeviceSession()) {
        navigate('/garcom/acesso', { replace: true });
        return;
      }

      try {
        setError('');
        await fetchWaiterDeviceSession();
        if (active) setReady(true);
      } catch (err) {
        if (err?.status === 401) {
          clearWaiterDeviceSession();
          if (active) navigate('/garcom/acesso', { replace: true });
          return;
        }
        if (active) setError('Não foi possível verificar o acesso agora. Confira a conexão e tente novamente.');
      }
    };

    validateSession();
    return () => {
      active = false;
    };
  }, [navigate, retryCount]);

  if (!ready) {
    return (
      <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', bgcolor: '#f8fafc' }}>
        <Stack spacing={2} alignItems="center" sx={{ width: '100%', maxWidth: 440, px: 2 }}>
          {error ? (
            <>
              <Alert severity="warning" sx={{ width: '100%' }}>{error}</Alert>
              <Button variant="contained" onClick={() => setRetryCount((value) => value + 1)}>
                Tentar novamente
              </Button>
            </>
          ) : (
            <>
              <CircularProgress aria-label="Verificando acesso do Garçom" />
              <Typography color="text.secondary">Verificando acesso do Garçom…</Typography>
            </>
          )}
        </Stack>
      </Box>
    );
  }

  return <Garcom deviceMode />;
};

export default WaiterOperation;
